<template>
  <form @submit.prevent>
    <v-row>
      <template v-for="(field, i) in schema">
        <v-col v-bind="field.grid" :key="i">
          <template v-if="field.required">
            <validation-provider :name="field.label" :rules="field.rules || 'required'" v-slot="{ errors }">
              <template v-if="field.mask">
                <component
                  :is="field.type"
                  :value="formData[field.name]"
                  @input="updateForm(field.name, $event)"
                  :label="`${field.label} *`"
                  v-bind="field"
                  v-mask="field.mask"
                  :items="field.items"
                  :error-messages="errors"
                />
              </template>
              <template v-else-if="field.decimal">
                <component
                  :is="field.type"
                  :value="formData[field.name]"
                  @input="updateForm(field.name, $event)"
                  :label="`${field.label} *`"
                  v-bind="field"
                  v-decimal
                  :items="field.items"
                  :error-messages="errors"
                />
              </template>
              <template v-else>
                <component
                  :is="field.type"
                  :value="formData[field.name]"
                  @input="updateForm(field.name, $event)"
                  :label="`${field.label} *`"
                  v-bind="field"
                  :items="field.items"
                  :error-messages="errors"
                />
              </template>
            </validation-provider>
          </template>
          <template v-else>
            <template v-if="field.mask">
              <component
                :is="field.type"
                :value="formData[field.name]"
                @input="updateForm(field.name, $event)"
                :label="`${field.label}`"
                v-bind="field"
                v-mask="field.mask"
                :items="field.items"
              />
            </template>
            <template v-else-if="field.decimal">
              <component
                :is="field.type"
                :value="formData[field.name]"
                @input="updateForm(field.name, $event)"
                :label="`${field.label}`"
                v-bind="field"
                v-decimal
                :items="field.items"
              />
            </template>
            <template v-else>
              <component
                :is="field.type"
                :value="formData[field.name]"
                @input="updateForm(field.name, $event)"
                :label="`${field.label}`"
                v-bind="field"
                :items="field.items"
              />
            </template>
          </template>
        </v-col>
      </template>
    </v-row>
  </form>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { mask } from 'vue-the-mask';
import { VAutocomplete, VSelect, VTextarea, VTextField, VCheckbox } from 'vuetify/lib';
import VRadio from './FormRadio';
import VDatePicker from './DatePicker';
export default {
  name: 'FormGenerator',
  components: { ValidationProvider, VAutocomplete, VSelect, VTextarea, VTextField, VRadio, VCheckbox, VDatePicker },
  props: ['schema', 'value'],
  directives: {
    mask,
    decimal: {
      // directive definition
      bind: function (el, binding, vnode) {
        let handler = function (e) {
          /* eslint-disable no-useless-escape  */
          let filteredVal = (e.target.value || '')
            .replace(/,/g, '.')
            .replace(/[^\d\.]/g, '')
            .replace(/^\./, '0.')
            .replace(/^(\d+(\.\d*)?).*$/, '$1');

          if (filteredVal !== e.target.value) {
            e.target.value = filteredVal;
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };
        el.addEventListener('input', handler);
      },
    },
  },
  data() {
    return {
      formData: this.value || {},
    };
  },
  methods: {
    updateForm(fieldName, value) {
      this.$set(this.formData, fieldName, value);
      this.$emit('input', this.formData);
    },

    validate() {},
  },
  watch: {
    value: function (value) {
      this.formData = value;
    },
  },
};
</script>

<style scoped></style>
